import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'
import { DATETIME_FORMAT } from '../../../core/utils/i18n-js'

import { Table, Button, Typography, Space, Popconfirm } from 'antd'
import { DownloadOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'

const FolderIcon = require('../../../assets/icons/fm-folder.png')
const DocumentIcon = require('../../../assets/icons/fm-document.png')

const { Text } = Typography

const propTypes = {
  data: PropTypes.object,

  onDownloadFolder: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired,

  onDeleteFolder: PropTypes.func.isRequired,

  showRenameForm: PropTypes.func.isRequired,

  allowRename: PropTypes.bool.isRequired,
  allowDelete: PropTypes.bool.isRequired,
  allowZip: PropTypes.bool.isRequired
}

const defaultProps = {
  data: {}
}

const columns = (props) => {
  const {
    onClickFolder,
    onDownloadFile,
    onDownloadFolder,
    onDeleteFile,
    onDeleteFolder,
    showRenameForm,
    allowRename,
    allowDelete,
    allowZip
  } = props

  const cols = [
    {
      title: 'Type',
      dataIndex: 'type',
      width: 30,
      render: (type) => type === 'folder'
        ? (
          <img alt='folder' src={FolderIcon} width={24} />
          )
        : (
          <img alt='file' src={DocumentIcon} width={24} />
          )
    }, {
      title: 'Name',
      dataIndex: 'name',
      render: (text, record) => {
        if (record.type === 'folder') {
          return (
            <Button type='link' onClick={() => onClickFolder(record)}>
              {text}
            </Button>
          )
        }
        return <Text>{text}</Text>
      }
    }, {
      title: 'Size',
      dataIndex: 'size',
      width: 60,
      align: 'right'
    }, {
      title: 'Date',
      dataIndex: 'last_modified',
      width: 150,
      render: (date) => {
        if (date) {
          return <Text>{Moment(date).format(DATETIME_FORMAT)}</Text>
        }
        return null
      }
    }, {
      key: 'action',
      width: 100,
      align: 'right',
      render: (_, record) => {
        const isFolder = record?.type === 'folder'
        const allowDownload = isFolder ? allowZip : true
        const onClickEdit = () => showRenameForm(record)
        const onClickDownload = () => isFolder ? onDownloadFolder(record) : onDownloadFile(record)
        const onClickDelete = () => isFolder ? onDeleteFolder(record) : onDeleteFile(record)

        if (isFolder && !allowRename && !allowDelete && !allowZip) {
          return null
        }
        return (
          <Space size='small'>
            {allowDownload && (
              <Button size='small' onClick={onClickDownload}>
                <DownloadOutlined />
              </Button>
            )}

            {props.allowRename && (
              <Button size='small' onClick={onClickEdit}>
                <EditOutlined />
              </Button>
            )}
            {props.allowDelete && (
              <Popconfirm title='Are you sure?' onConfirm={onClickDelete} okText='Yes' cancelText='No'>
                <Button size='small' danger type='dashed'>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            )}
          </Space>
        )
      }
    }
  ]

  return cols
}

const FileManager = (props) => {
  const { data } = props

  return <Table columns={columns(props)} dataSource={data?.data || []} size='small' pagination={false} bordered />
}

FileManager.propTypes = propTypes
FileManager.defaultProps = defaultProps

export default FileManager
